import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'platform/components';
import { Text, ThemeTextColorPath } from 'platform/foundation-tw';
import { useDateTimeFormatter } from 'platform/locale';
import { parseDate } from 'shared/web';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getStylesToRender } from '../../utils/getStylesToRender';
import { getTooltipProps } from '../../utils/getTooltipProps';
type DateTimeCellRendererProps = CellRendererProps<string | null> & {
  getTooltipProps?: TooltipGetter;
};
type CellStyle = {
  textColor?: ThemeTextColorPath;
};
export function DateTimeCellRenderer(props) {
  const $ = _c(37);
  let t0;
  if ($[0] !== props.column) {
    t0 = getCellClassName(props.column);
    $[0] = props.column;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const className = t0;
  let t1;
  if ($[2] !== props) {
    t1 = getStylesToRender(props);
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const cellStyles = t1 as CellStyle | undefined;
  const formatDateTime = useDateTimeFormatter();
  let t2;
  if ($[4] !== props.getTooltipProps || $[5] !== props.row) {
    t2 = getTooltipProps(props.row, {}, props.getTooltipProps);
    $[4] = props.getTooltipProps;
    $[5] = props.row;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const tooltipProps = t2;
  if (!props.value) {
    return null;
  }
  let T0;
  let T1;
  let t10;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[7] !== cellStyles?.textColor || $[8] !== className || $[9] !== formatDateTime || $[10] !== props.column?.wrapText || $[11] !== props.value || $[12] !== tooltipProps) {
    t10 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const parsed = parseDate(props.value);
      if (isNaN(parsed.getTime())) {
        t10 = null;
        break bb0;
      }
      T1 = Tooltip;
      t8 = tooltipProps;
      t9 = formatDateTime("dateTimeLong", parsed);
      t7 = className;
      T0 = Text;
      t3 = cellStyles?.textColor;
      t4 = !props.column?.wrapText;
      t5 = "small";
      t6 = formatDateTime("dateTimeShort", parsed);
    }
    $[7] = cellStyles?.textColor;
    $[8] = className;
    $[9] = formatDateTime;
    $[10] = props.column?.wrapText;
    $[11] = props.value;
    $[12] = tooltipProps;
    $[13] = T0;
    $[14] = T1;
    $[15] = t10;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    T0 = $[13];
    T1 = $[14];
    t10 = $[15];
    t3 = $[16];
    t4 = $[17];
    t5 = $[18];
    t6 = $[19];
    t7 = $[20];
    t8 = $[21];
    t9 = $[22];
  }
  if (t10 !== Symbol.for("react.early_return_sentinel")) {
    return t10;
  }
  let t11;
  if ($[23] !== T0 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t11 = <T0 color={t3} noWrap={t4} size={t5}>{t6}</T0>;
    $[23] = T0;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== t7) {
    t12 = <div className={t7}>{t11}</div>;
    $[29] = t11;
    $[30] = t7;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== T1 || $[33] !== t12 || $[34] !== t8 || $[35] !== t9) {
    t13 = <T1 {...t8} label={t9}>{t12}</T1>;
    $[32] = T1;
    $[33] = t12;
    $[34] = t8;
    $[35] = t9;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
}